import React, { useEffect, useState } from 'react'
import Logo from '../assets/images/logo.png'
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  return (
    <>
      {/* Top Bar */}
      <div className='header-top-bar'>
        <div className='container'>
          <div className='top-bar-content'>
            <div className='top-bar-left'>
              <div className='location-info'>
                <i className="fas fa-map-marker-alt"></i>
                <span>YOU ARE IN WORLDWIDE</span>
              </div>
            </div>
            <div className='top-bar-right'>
              <Link to="/contact" className='top-bar-link' style={{ textDecoration: 'none' }}>
                <i className="fas fa-envelope"></i>
                <span>MAKE AN ENQUIRY</span>
              </Link>
              <Link to="/contact" className='top-bar-link' style={{ textDecoration: 'none' }}>
                <i className="fas fa-phone"></i>
                <span>CONTACT</span>
              </Link>
              <button className='search-btn'>
                <i className="fas fa-search"></i>
                <span>SEARCH</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`main-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className='container'>
          <div className='header-content'>
            {/* Logo */}
            <div className='header-logo'>
              <Link to="/">
                <img src={Logo} alt="Logo" className='logo-img' />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className='desktop-nav'>
              <ul className='nav-menu'>
                <li className='nav-item'>
                  <Link to="/" className='nav-link'>ABOUT TFS</Link>
                </li>
                <li className='nav-item'>
                  <Link to="/warehousing" className='nav-link'>WAREHOUSING</Link>
                </li>
                <li className='nav-item'>
                  <Link to="/vas-activity" className='nav-link'> VAS ACTIVITY</Link>
                </li>
                <li className='nav-item'>
                  <Link to="/transportation" className='nav-link'>FREIGHT & TRANSPORTATION</Link>
                </li>
                <li className='nav-item'>
                  <Link to="/services" className='nav-link'>SERVICES OFFERED</Link>
                </li>


                <li className='nav-item'>
                  <Link to="/contact" className='nav-link'>CONTACT</Link>
                </li>

              </ul>
            </nav>

            {/* Mobile Menu Toggle */}
            <button className='mobile-menu-toggle' onClick={toggleMenu}>
              <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          <div className='mobile-nav-overlay' onClick={toggleMenu}></div>
          <div className='mobile-nav-content'>
            <button className='mobile-close-btn' onClick={toggleMenu}>
              <i className="fas fa-times"></i>
            </button>
            <div className='mobile-top-links'>
              <Link to="/contact" className='mobile-link' onClick={toggleMenu}>
                <i className="fas fa-envelope"></i> MAKE AN ENQUIRY
              </Link>
              <Link to="/contact" className='mobile-link' onClick={toggleMenu}>
                <i className="fas fa-phone"></i> CONTACT
              </Link>
            </div>
            <ul className='mobile-menu'>
              <li className='mobile-nav-item'>
                <Link to="/vas-activity" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-cogs"></i> ABOUT TFS
                </Link>
              </li>
              <li className='mobile-nav-item'>
                <Link to="/warehousing" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-warehouse"></i> WAREHOUSING
                </Link>
              </li>
              <li className='mobile-nav-item'>
                <Link to="/vas-activity" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-cogs"></i> VAS ACTIVITY
                </Link>
              </li>
              <li className='mobile-nav-item'>
                <Link to="/transportation" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-truck"></i> FREIGHT & TRANSPORTATION
                </Link>
              </li>
              <li className='mobile-nav-item'>
                <Link to="/services" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-concierge-bell"></i> SERVICES OFFERED
                </Link>
              </li>

              <li className='mobile-nav-item'>
                <Link to="/contact" className='mobile-nav-link' onClick={toggleMenu}>
                  <i className="fas fa-envelope"></i> CONTACT
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  )
}
